// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { getCurrencySymbol } from 'simple-currency-format';

import './DiamondDetailsContent.style';
import { color_diamonds } from 'Src/Value/ColorDiamond_color';

export class DiamondDetailsContent extends PureComponent {
    static propTypes = {
        ringdiamond: this.propTypes
    };

    render() {
        const { ringdiamond } = this.props;

        return (
            <div className="ProductAttributes-Attributes">
                {ringdiamond?.diamond_sku && <dl className="ProductAttributes-AttributeContainer">
                    <dt className="ProductAttributes-AttributeLabel">SKU:</dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className="ProductAttributeValue">{ringdiamond?.diamond_sku}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_created_from && <dl className="ProductAttributes-AttributeContainer">
                    <dt className="ProductAttributes-AttributeLabel">Diamond Type:</dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className="ProductAttributeValue">{ringdiamond?.diamond_created_from}</div>
                    </dd>
                </dl>}
                {/* {ringdiamond?.diamond_price && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Price: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{getCurrencySymbol("USD")}{ringdiamond?.diamond_price}</div>
                    </dd>
                </dl>} */}
                {ringdiamond?.diamond_shape && <dl className="ProductAttributes-AttributeContainer">
                    <dt className="ProductAttributes-AttributeLabel">Shape:</dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className="ProductAttributeValue">{ringdiamond?.diamond_shape}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_cut && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Cut: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_cut}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_carat && <dl className="ProductAttributes-AttributeContainer">
                    <dt className="ProductAttributes-AttributeLabel">Carat:</dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className="ProductAttributeValue">{ringdiamond?.diamond_carat}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_clarity && <dl className="ProductAttributes-AttributeContainer">
                    <dt className="ProductAttributes-AttributeLabel">Clarity:</dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className="ProductAttributeValue">{ringdiamond?.diamond_clarity}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_color && <dl className="ProductAttributes-AttributeContainer">
                    <dt className="ProductAttributes-AttributeLabel">Color:</dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className="ProductAttributeValue">{ringdiamond?.hasColor ? color_diamonds[ringdiamond?.diamond_color?.toLowerCase()] : ringdiamond?.diamond_color}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_certificate && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Certificate: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_certificate}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_depth && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Depth %: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_depth} %</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_table_percent && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Table %: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_table_percent} %</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_polish && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Polish: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_polish}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_symmetry && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Symmetry: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_symmetry}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_measurement && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Measurement: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_measurement}</div>
                    </dd>
                </dl>}
                {(ringdiamond?.girdle_max || ringdiamond?.girdle_min) && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Gridle: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>
                            {ringdiamond?.girdle_max}
                            {ringdiamond?.girdle_max && ringdiamond?.girdle_min ? " , " : ""}
                            {ringdiamond?.girdle_min}
                        </div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_culet && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Culet: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_culet}</div>
                    </dd>
                </dl>}
                {ringdiamond?.diamond_fluorescence && <dl className='ProductAttributes-AttributeContainer'>
                    <dt className='ProductAttributes-AttributeLabel'>Fluorescence: </dt>
                    <dd className="ProductAttributes-ValueLabel">
                        <div className='ProductAttributeValue'>{ringdiamond?.diamond_fluorescence}</div>
                    </dd>
                </dl>}
            </div>
        );
    }
}

export default DiamondDetailsContent;
